import { render, staticRenderFns } from "./DashboardApprovalAging.vue?vue&type=template&id=66951c38&"
import script from "./DashboardApprovalAging.vue?vue&type=script&lang=js&"
export * from "./DashboardApprovalAging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports